<template>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
        :width="width" 
        :height="height"
        :viewBox="viewbox">
        <!-- Background circle -->
        <path fill="transparent"
            :d="dBg" 
            :stroke="backgroundColor"
            :stroke-width="strokeWidth"/>
        <!-- Foreground circle -->
        <path fill="transparent"
            :d="d"          
            :stroke="foregroundColor"
            :stroke-width="strokeWidth"/>
        <!-- info text -->
        <text x=100 y=80 fill="#9094A3" font-size="12px" text-anchor="middle">{{remainingText}}</text>
        <text x=100 y=116  text-anchor="middle">
            <tspan fill="#2E3242" font-size="30px">{{remainingData}}</tspan>
            <tspan fill="#9094A3" font-size="12px">{{remainingDataUnit}}</tspan>
        </text>
    </svg>
</template>

<script>
export default {
  name: "index",
  props: {
    height: {
      type: Number,
      default: 200
    },
    percent: {
      type: Number
    },
    radius: {
      type: Number
    },
    strokeWidth: {
      type: Number,
      default: 15
    },
    width: {
      type: Number,
      default: 200
    },
    foregroundColor: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: "#E6E9F5"
    },
    remainingText: {
      type: String,
      default: "剩余"
    },
    remainingData: {
      type: Number
    },
    remainingDataUnit: {
      type: String
    }
  },
  computed: {
    x() {
      return 100;
    },
    y() {
      return 100 - this.radius;
    },
    z() {
      return this.percent === 100 ? "z" : "";
    },
    viewbox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    endX() {
      return -Math.sin(this.radians) * this.radius + 100 - 0.0001;
    },
    endY() {
      return Math.cos(this.radians) * this.radius + 100;
    },
    largeArc() {
      return this.percent < 50 ? 0 : 1;
    },
    radians() {
      let degress = this.percent / 100 * 360;
      let value = degress - 180;
      return value * Math.PI / 180;
    },
    dBg() {
      return `M ${this.x} ${this.y} A ${this.radius} ${this.radius} 0 1 1 ${this
        .x - 0.0001} ${this.y} z`;
    },
    d() {
      return `M ${this.x} ${this.y} A ${this.radius} ${this.radius} 0 ${
        this.largeArc
      } 1 ${this.endX} ${this.endY} ${this.z}`;
    }
  }
};
</script>

<style scoped lang="scss">
</style>